function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M10.8839 16.877C10.7212 17.0397 10.4574 17.0397 10.2947 16.877L9.70541 16.2878C9.54269 16.125 9.54269 15.8612 9.70541 15.6985L13.4039 12L9.70542 8.30147C9.5427 8.13875 9.5427 7.87493 9.70542 7.71222L10.2947 7.12296C10.4574 6.96024 10.7212 6.96024 10.8839 7.12296L15.4654 11.7044C15.5471 11.7862 15.5878 11.8934 15.5874 12.0005C15.5875 12.1073 15.5468 12.2141 15.4654 12.2956L10.8839 16.877Z",
  fill: "white"
});

var SvgChevronRightInCircleFill = function SvgChevronRightInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronRightInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right-in-circle-fill.d324718a.svg";
export { ForwardRef as ReactComponent };